import { CouplerStyleFilter } from './couplerStyleFilter';
import { apiFetch } from '@ami/react/core';
import { CouplerManufacturingDataType } from './couplerManufacturingDataType';
import { CouplerStylePartNumberFilter } from './couplerStylePartNumberFilter';
import { QuoteCouplerStyle } from '../quotes/quoteProductConfiguration';

const _baseEndPoint = 'coupler-styles';

export const CouplerAvailability = Object.freeze({
  AmiCouplers: 'AMI Couplers',
  ExistingCouplers: 'Existing Couplers',
  AmiTiltRotators: 'AMI Tilt Rotators',
  ExistingTiltRotators: 'Existing Tilt Rotators',
});

export const CouplerOilReadyType = Object.freeze({
  None: 'None',
  OilQuick: 'OilQuick',
  SmartFlow: 'SmartFlow',
  EngconEcOil: 'Engcon EC-Oil',
  RototiltQuickChange: 'Rototilt QuickChange',
  SteelWristSq: 'SteelWrist SQ',
});

export class CouplerStyle extends QuoteCouplerStyle {
  constructor(item) {
    super(item);
    if (item) {
      this.oilReadinessData = item.oilReadinessData.map(
        (x) => new OilReadinessData(x)
      );
      this.carrierId = item.carrierId;
      this.carrierName = item.carrierName;
      this.weightCategoryName = item.weightCategoryName;
      this.tipRadiusUnitsName = item.tipRadiusUnitsName;
      this.attachmentPointName = item.attachmentPointName;
      this.availabilities = item.availabilities;
      this.thumbClassId = item.thumbClassId;
      this.thumbClassName = item.thumbClassName;
      this.thumbPinKitId = item.thumbPinKitId;
      this.thumbPinKitName = item.thumbPinKitName;
      this.thumbShimKitId = item.thumbShimKitId;
      this.thumbShimKitName = item.thumbShimKitName;
      this.hardenedStickPinKitId = item.hardenedStickPinKitId;
      this.hardenedStickPinKitName = item.hardenedStickPinKitName;
      this.hardenedLinkPinKitId = item.hardenedLinkPinKitId;
      this.hardenedLinkPinKitName = item.hardenedLinkPinKitName;
      this.forceThumbToUseMachinePinUpSpecs = item.forceThumbToUseMachinePinUpSpecs;
      this.pinDiameterRanges = item.pinDiameterRanges == null ? null : new CouplerPinDiameterRanges(item.pinDiameterRanges);
      return;
    }
    this.label = '';
    this.oilReadinessData = [new OilReadinessData()];
    this.carrierId = null;
    this.carrierName = '';
    this.weightCategorName = '';
    this.tipRadiusUnitsName = '';
    this.attachmentPointName = '';
    this.availabilities = [];
    this.thumbClass = null;
    this.thumbClassName = '';
    this.thumbPinKit = null;
    this.thumbPinKitName = '';
    this.thumbShimKit = null;
    this.thumbShimKitName = '';
    this.hardenedStickPinKit = null;
    this.hardenedStickPinKitName = '';
    this.hardenedLinkPinKit = null;
    this.hardenedLinkPinKitName = '';
    this.forceThumbToUseMachinePinUpSpecs = false;
    this.availableOilReadyTypes = [];
  }

  static search(filter = new CouplerStyleFilter(), page) {
    filter.setPaginationParameters(page);
    return apiFetch(`${_baseEndPoint}?${filter.toQueryString()}`);
  }

  static searchPartNumber(filter = new CouplerStylePartNumberFilter(), page) {
    filter.setPaginationParameters(page);
    return apiFetch(`${_baseEndPoint}/part-numbers?${filter.toQueryString()}`);
  }

  static async getById(id) {
    const entity = await apiFetch(`${_baseEndPoint}/${id}`);
    return new CouplerStyle(entity);
  }

  static create(item) {
    return apiFetch(_baseEndPoint, 'POST', item);
  }

  static getCouplerStyleType() {
    return apiFetch(`${_baseEndPoint}/coupler-style-type`);
  }

  update() {
    return apiFetch(`${_baseEndPoint}/${this.id}`, 'PUT', this);
  }

  delete() {
    return apiFetch(`${_baseEndPoint}/${this.id}`, 'DELETE', this);
  }
}

export class CouplerPinDiameterRanges {
  constructor(range) {
    this.minStickPinDiameterInMm = range?.minStickPinDiameterInMm || null;
    this.maxStickPinDiameterInMm = range?.maxStickPinDiameterInMm || null;
    this.minLinkPinDiameterInMm = range?.minLinkPinDiameterInMm || null;
    this.maxLinkPinDiameterInMm = range?.maxLinkPinDiameterInMm || null;
  }
}

export const CouplerStylePartNumberLogic = Object.freeze({
  AppendPartNumberToProductOrProductOption:
    'Append part number to Product or Product Option',
  AppendLuggingPinSpecThenPartNumber:
    "Append machine's Lugging Pin Spec, then append part number",
  AppendLuggingPinSpecOnly: "Use machine's Lugging Pin Spec",
});

export class OilReadinessData {
  constructor(item) {
    if (item) {
      this.oilReadyType = item.oilReadyType;
      this.manufacturingData = item.manufacturingData.map(
        (x) => new ManufacturingData(x)
      );
      return;
    }

    this.oilReadyType = CouplerOilReadyType.None;
    this.manufacturingData = Object.keys(CouplerManufacturingDataType)
      .filter(
        (x) =>
          x === 'Coupler' ||
          x === 'NonHydraulicAttachment' ||
          x === 'HydraulicAttachment'
      )
      .map((type) => new ManufacturingData({ type }));
  }
}

export class ManufacturingData {
  constructor(item) {
    if (item) {
      this.type = item.type;
      this.partNumber = item.partNumber || '';
      this.partNumberLogic = item.partNumberLogic;
      this.supportsFastTrackLeadTimes =
        item.supportsFastTrackLeadTimes || false;
     this.requireFullEngineeringLeadTimes =
        item.requireFullEngineeringLeadTimes || false;
      this.surchargeAmount = item.surchargeAmount || 0;
    }
  }
}
